// src/breadcrumbMap.js
const breadcrumbMap = {
  "/": ["Dashboard"],
  "/user/create-user": ["User", "Create User"],
  "/user/all-user-list": ["User", "All User List"],
  "/point-management/user-wallet-balance": ["Point Management", "User Wallet Balance"],
  "/user/active-user-list": ["User", "Active User List"],
  "/user/login-user-list": ["User", "Login User List"],
  "/user/unapprove-user-list": ["User", "Unapproved User List"],
  "/game/main-market-list": ["Game", "Main Market List"],
  "/game/delhi-market-list": ["Game", "Delhi Market List"],
  "/game/starline-market-list": ["Game", "Starline Market List"],
  "/withdrawal-pending": ["Withdrawal", "Pending"],
  "/withdrawal-complete": ["Withdrawal", "Complete"],
  "/withdrawal-reject": ["Withdrawal", "Reject"],
  "/point-management-add-point": ["Point Management", "Add Point"],
  "/point-management-Deduct-point": ["Point Management", "Deduct Point"],
  "/point-management/add-point-history": ["Point Management", "Add Point History"],
  "/point-management/auto-point-history": ["Point Management", "Auto Point History"],
  "/declare-result/main-market": ["Declare Result", "Main Market"],
  "/declare-result/delhi-market": ["Declare Result", "Delhi Market"],
  "/declare-result/starline-market": ["Declare Result", "Starline Market"],
  "/main-market-list": ["Running Game", "Main Market"],
  "/delhi-market-list": ["Running Game", "Delhi Market"],
  "/starline-market-list-n": ["Running Game", "Starline Market"],
  "/all-game-rate": ["Game Rates", "All Game Rates"],
  "/upload-old-main-market-list": ["Upload Old Result", "Main Market"],
  "/upload-old-delhi-market-list": ["Upload Old Result", "Delhi Market"],
  "/upload-old-starline-market-list-n": ["Upload Old Result", "Starline Market"],
  "/report-managment/user-bid-analysis": ["Reports", "User Bid Analysis"],
  "/report-managment/user_bid_report_index": ["Reports", "User Bid Report"],
  "/report-managment/user_full_biding_details": ["Reports", "Full Bidding Details"],
  "/report-managment/transaction-history": ["Reports", "Transaction History"],
  "/report-managment/user-winner-history": ["Reports", "Winner History"],
  "/report-managment/bid-analysis": ["Reports", "Result Analysis"],
  "/banners/index": ["Banners"],
  "/notice-management": ["Notice Management"],
  "/setting/appsetting": ["Settings", "App Setting"],
  "/notification/notification-list": ["Notification", "Send Notification"],
};

export default breadcrumbMap;
